import React, { useCallback } from 'react';

import { Button, Icon, TextInput, Unform } from 'components';
import { forgetPasswordValidationSchema } from 'yupSchemas/login';
import { Flex, Heading, Link, Stack } from '@chakra-ui/react';
import { postResetPassword } from 'services/auth';
import { RouteComponentProps, useHistory } from 'react-router';
import { IResetPasswordData } from 'types/auth';
import { openNotification } from 'utils/notification';
import { routePaths } from 'constants/routes';
import { ImgLogo as Image } from '../Login/styles';

import logoDaniel from '../assets/logo-daniel.svg';

export const ForgetPassword: React.FC<RouteComponentProps> = () => {
  const history = useHistory();
  const [isLoading, setIsLoading] = React.useState(false);
  const [emailSent, setEmailSent] = React.useState<any>(false);
  const [userEmail, setUserEmail] = React.useState<string>('');

  const handleRecoveryPassword = useCallback(async (formData: IResetPasswordData) => {
    try {
      setIsLoading(true);
      const response = await postResetPassword(formData);
      setUserEmail(formData.user_recover);
      setEmailSent(response.data);

      if (!response.data) {
        openNotification('Usuário não encontrado', 'error');
      } else {
        openNotification('Email enviado', 'success');
      }
    } catch (error) {
      openNotification('Usuário não encontrado', 'error');
    } finally {
      setIsLoading(false);
    }
  }, []);

  const DefaultRecoverPasswordForm = (): JSX.Element => (
    <>
      <Stack
        direction={['row', 'row']}
        spacing="1rem"
        mb="1rem"
        justifyContent="center"
        alignItems="center"
        marginTop={'-3rem'}
      >
        <Heading size="md" mb="1rem" color="#21272b" mt="2rem">
          Esqueceu sua senha?
        </Heading>
      </Stack>
      <Heading
        marginTop="-1rem  "
        size="md"
        mb="1rem"
        fontWeight={400}
        fontSize={14}
        lineHeight={'21px'}
        color={'#3B454F'}
      >
        Digite o email associado à sua conta no DPO Hub e nós vamos lhe enviar um email com o código
        de verificação para trocar sua senha.
      </Heading>

      <Unform validationSchema={forgetPasswordValidationSchema} onSubmit={handleRecoveryPassword}>
        <TextInput
          label="Email"
          color="brand.900"
          name="user_recover"
          background="#fff"
          placeholder="exemplo@exemplo.com"
          border={'1px solid #CCD1D6 !important'}
          height={'50px'}
        />
        <Button type="submit" isLoading={isLoading} fullWidth>
          Enviar Email
        </Button>
      </Unform>
    </>
  );

  return (
    <>
      {emailSent ? (
        history.push(`${routePaths.verificationCode}?email=${userEmail}`)
      ) : (
        <Flex height="100vh" alignItems="center" justifyContent="center">
          <Flex direction="column" p={12} alignItems="center" justifyContent="center">
            <Flex
              width="400px"
              alignItems="center"
              direction="column"
              background="#fff"
              p={8}
              paddingTop={'4'}
              rounded={6}
              boxShadow={'0px 4px 20px rgba(0,0,0,0.20);'}
            >
              <Link href={routePaths.login} my="0.5em" alignSelf="flex-start">
                <Icon size={1.5} name={'arrowLeft'} color="black700" />
              </Link>
              <Flex justify="center" align="center" height="7rem">
                <Image src={logoDaniel} alt="Logo DPO Hub" width="100%" height="100%" />
              </Flex>

              <DefaultRecoverPasswordForm />
            </Flex>
          </Flex>
        </Flex>
      )}
    </>
  );
};
